import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const FinancialInfo = Loadable({
  loader: () => import("./components/financial-info"),
  loading: Loading
});

export const routes = [
  {
    path: '/financial-info',
    exact: true,
    name: 'financial-info',
    component: FinancialInfo,
    // "permission": {
    //   "contactype": [
    //     "affiliate"
    //   ],
    //   "group": [
    //     "Staff Carers"
    //   ]
    // }
  }
];